import { useDataSubmit, useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  let comment = useDataValue({
    context: 'task_comment',
    path: 'comment',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'task_comment',
    path: 'comment',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'create_task_comment',
      task_id,
      comment,
    })
    change('')
  }
}
